export const assigneesConstants = {
  ASSIGNEES_REQUEST: 'ASSIGNEES_REQUEST',
  ASSIGNEES_SUCCESS: 'ASSIGNEES_SUCCESS',
  ASSIGNEES_ERROR: 'ASSIGNEES_ERROR',
};
